import { useDispatch, useSelector } from "react-redux"
import { ActionNR, NRFormProducto } from "../interfaces/nota-remision.interface"
import { NOTA_REMISION_TYPES } from "../constants/nota-remision-types"
import { State } from "../reducers"
import { REGEX_EMAIL, REGEX_INTEGER, REGEX_LETRAS_ESPACIOS, REGEX_NIT, REGEX_NRC } from "../constants/Regex"
import * as http from '../api/http'
import { ENDPOINTS } from "../api/config"
import { KEYS } from "../constants/keysStorage"
import { generalOpenConfirmEdit, generalOpenModalError, generalOpenModalInfo, generalOpenModalMessage, generalOpenToastError, generalOpenToastInfo, generalOpenToastSuccess, generalShowLoader, getFechaHora } from "./general.actions"
import { useEffect } from "react"

import FlechaDerechaIcon from '../media/felsv/white_right-arrow_icon.svg'
import EmitirIcon from '../media/felsv/white_check_icon.svg'
import MasOpcionesIcon from '../media/felsv/WhiteOpciones.svg'
import { getEmailNotifyMsg, unirChipsJoin, unirChipsReturnFirst, validarRegexLetras, validarRegexNumericoFloat2Decimales, validarRegexNumericoInt } from "../utils/strings.utils"
import { getMunicipios } from "./catalogos.actions"
import { validarTipoDocumento } from "../utils/validaciones"
import { facturacionGetUUID } from "./facturacion/facturacionEmision.actions"
import { convertDateFormatAnular, getFechaCA, getFechaFormato1 } from "../utils/stringDate"
import { anularFactura_DTE, descargarJson, generateQRImageFromBits, getExcelFactura, getFacturaImage, getFacturaPDF_New, getQR, sendTransactionEmail } from "./operaciones/operaciones.actions"
import { useHistory } from "react-router-dom"
import { OPSendEmail } from "../interfaces/operaciones.interface"
import { showMessageSucursalVacia } from "./userLogin.actions"
import { docsDatosReceptorReset, docsDatosReceptorSiguienteDispatch } from "./documentos/documentos.actions"
import { DocFisico } from "../interfaces/general.interface"
import useUtilsDocs from "./utils-documentos.actions"

export default function useNotaRemision () {
    const dteCode = "04";
    const {formCliente, formProducto, errorsCliente, errorsProducto, productos, view, productoEdit, productoIndex, response_Emitir, clienteEncontrado, asociarDocumentos, documentosAsociados, formBusquedaDocumento, errorsFormBusquedaDocumento, mostrarDetalle} = useSelector((state: State) => state.notaRemision)
    const {departamentos, actividadesEconomicas, datosEmisor, unidadesMedida, tipoDocumentosEmision} = useSelector((state: State) => state.catalogos)
    const {datosUUID} = useSelector((state: State) => state.facturacion)
    const {datos} = useSelector((state: State) => state.userLogin)
    const datosReceptor = useSelector((state: State) => state.documentos.datosReceptor.form);

    const dispatch = useDispatch()
    const history = useHistory()
    const emisorGranContribuyente = datosEmisor?.tipoContribuyente === '1'
    const emisorJuridico = datosEmisor?.tipoEmpresa === '1'

    const {processFormCatalogoProducto, processOtrosImpuestosCalculo, procesOtrosImpuestosResumen, getTributosCatalogoProducto} = useUtilsDocs();

    const cargarDatosIniciales = () => {
        let fechaActual = new Date().toISOString().split('T')[0]
        let sucursalConDocumento = formCliente?.datosSucursal?.find((suc: any) => suc.Documento.find((doc: any) => doc.iddocumento === '4'))
        let documentoSucursal = sucursalConDocumento?.Documento.find((doc: any) => doc.iddocumento === '4')

        dispatch(handleSetFormCliente({
            ...formCliente,
            fecha: fechaActual,
            sucursal: sucursalConDocumento?.idsucursal,
            serie: documentoSucursal?.idsucursaldocumento
        })) 
    }

    const onChangeFormCliente = (field: string, value: any) => {
        if(!validateChange(field, value) && value.trim() !== '') return
        dispatch(handleSetFormCliente({...formCliente, [field] : value}))
        validateFormCliente(field, value)
    }

    const onChangeFormProducto = (field: string, value: any, extraData = {}) => {
        if(!validateChange(field, value) && value.trim() !== '') return
        dispatch(handleSetFormProducto({...formProducto, ...extraData, [field] : value}))
        validateFormProducto(field, value)
    }

    const onChangeSelectCatalogoProducto = (codeProduct: string) => {
        const newFormProducto = processFormCatalogoProducto(dteCode, formProducto, codeProduct)
        dispatch(handleSetFormProducto({...formProducto, ...newFormProducto}))
        validateFormProducto('descripcion', codeProduct);
    }

    const onChangeFormBusquedaDocumento = (field: string, value: any) => {
        if(!validateChange(field, value) && value.trim() !== '') return
        dispatch(handleSetFormBusquedaDocumento({...formBusquedaDocumento, [field] : value}))
        validateFormBusquedaDocumento(field, value)
    }

    const validateFormCliente = (field: string, value: string) => {
        let message = ''

        switch (field) {
            case 'nombre':
                if(!value || value.trim() === ''){message = 'Nombre es requerido'; break;}         
                break;
            case 'nitTercero':
                if(!REGEX_NIT.test(value) && value.trim() !== '') {message = 'Formato de NIT incorrecto'; break}
                break;
            case 'noDocumento':
                if(!value || value.trim() === ''){message = 'Número de identificación es requerido.'}
                switch(formCliente.tipoDocumento){
                    case '36':
                        if(!REGEX_NIT.test(value)) {message = 'Formato de NIT incorrecto'; break}
                        break;
                    case '03':
                        message = validarTipoDocumento('pasaporte', value, '')
                        break;
                    case '13':
                        if(!REGEX_INTEGER.test(value) || value.length > 9 || value.length < 9) {message = 'Formato de DUI incorrecto'; break}
                        break;
                    case '02':
                        message = validarTipoDocumento('carnet de residente', value, '')
                        break;
                    case '37':
                        message = validarTipoDocumento('otro', value, '')
                        break;
                }
                break;
            case 'departamento':
                    if(!value || value.trim() === ''){message = 'Departamento es requerido.'}
                    if(value && value !== '' && value !== formCliente.departamento){
                        let nombreDepartamento = departamentos.find(departamento => departamento.codigo === value)?.valor
                        
                        if(nombreDepartamento){
                            dispatch(getMunicipios(parseInt(value), nombreDepartamento, true))
                            dispatch(handleSetFormCliente({...formCliente, departamentoDescripcion: nombreDepartamento, municipio: '', departamento: value}))
                        }
                    }
                break;
            case 'municipio':
                if(!value || value.trim() === ''){message = 'Municipio es requerido.'}
                break;
            case 'direccion':
                if(!value || value.trim() === ''){message = 'Dirección es requerida.'}
                break;
            case 'email':
                const chipsEmail = formCliente.chipsEmail?.length || 0;
                if (chipsEmail <= 0 && (!value || value.trim() === '')){message = 'Correo electrónico es requerido.'; break;}
                if (value.trim() !== "" && !REGEX_EMAIL.test(value)) {message = 'Correo electrónico inválido'; break;}
                break;
            case 'telefono':
                if(!value || value.trim() === ''){message = 'Teléfono celular es requerido.'; break;}
                if(value.trim().length < 11){message = 'Teléfono celular inválido.'; break;}
                break;
            case 'actividad':
                if(!value || value.trim() === ''){message = 'Actividad económica es requerida.'; break;}
                break;
            case 'nrc':
                if((!value || value.trim() === '') && formCliente.tipoDocumento === '36'){message = 'NRC es requerido.'; break;}
                if(!REGEX_NRC.test(value) && value.trim() !== ''){message = 'Formato de NRC incorrecto.'}
                break;
            case 'sucursal':
                if(!value || value === ''){message = 'Sucursal es requerida'}
                break;
            case 'serie':
                if(!value || value === ''){message = 'Serie es requerida'}
                break;
        }

        dispatch(handleErrorsFormCliente({
            ...errorsCliente,
            [field] : message
        }))

        return (message)
    }

    const validateFormProducto = (field: string, value: string) => {
        let message = ''
        
        switch(field){
            case 'descripcion':
                if(value.trim() === ''){message = 'Descripción es obligatoria.'; break;}
                break;
            case 'cantidad':
                if(value.trim() === '' || parseFloat(value) <= 0){message = 'La cantidad debe ser mayor a 0.'; break;}
                break;
            case 'precio':
                if(value.trim() === '' || parseFloat(value) < 0){message = 'El precio debe ser mayor a 0.'; break;}
                break;
            case 'descuento':
                let suma = parseFloat(formProducto.cantidad) * parseFloat(formProducto.precio)
                if(parseFloat(value) > 100 && formProducto.tipoDescuento === 'Porcentaje') {message = 'El porcentaje de descuento no puede ser mayor al 100%.'; break;}
                if(formProducto.tipoDescuento === 'Monto'){
                    if(parseFloat(value) > suma){message = 'El monto de descuento no puede ser mayor al precio.'; break;}
                }
                break;
        }
        dispatch(handleErrorsFormProducto({
            ...errorsProducto,
            [field] : message
        }))

        return (message)
    }

    const validateFormBusquedaDocumento = (field: string, value: string) => {
        let message = ''
        let fechaActual = new Date()

        switch(field){
            case 'tipoDocumento':
                if(value.trim() === '') message = 'El tipo de documento es obligatorio.'
                break;
            case 'fechaInicial':
                let fecha = new Date(value)
                if(fecha > fechaActual){message = 'La fecha de búsqueda inicial no puede ser mayor a la fecha actual.'; break;}
                if(value.trim() === ''){message = 'Fecha inicial es obligatoria.'; break;}
                break;
            case 'fechaFinal':
                let fechaFinal = new Date(value)
                let fechaInicial = new Date(formBusquedaDocumento.fechaInicial)
                if(fechaFinal > fechaActual){message = 'La fecha de búsqueda final no puede ser mayor a la fecha actual.'; break;}
                if(fechaFinal < fechaInicial){message = 'La fecha de búsqueda final no puede ser menor a la fecha de búsqueda inicial.'; break;}
                if(value.trim() === ''){message = 'Fecha final es obligatoria.'; break;}
                break;
            case 'cantidad':
                if(value.trim() === '' || parseFloat(value) < 0){message = 'La cantidad debe ser mayor a 0.'; break;}
                break;
            case 'noIdentificacion':
                switch(formBusquedaDocumento.tipoIdentificacion){
                    case '36':
                        if(!REGEX_NIT.test(value) && value.trim() !== '') {message = 'Formato de NIT incorrecto'; break}
                        break;
                    case '03':
                        const regexPasaporte = /^([a-zA-Z0-9]{5,20})$/i
                        if (!regexPasaporte.test(value) && value.trim() !== '') message = 'Formato de pasaporte incorrecto'
                        break;
                    case '13':
                        if(!REGEX_INTEGER.test(value) || value.length > 9 || value.length < 9 && value.trim() !== '') {message = 'Formato de DUI incorrecto'; break}
                        break;
                    case '02':
                        const regex = /^([0-9]{5,10})$/i
                        if(!regex.test(value) && value.trim() !== '') {message = 'Formato incorrecto de carnet de residente'; break}
                        break;
                    case '37':
                        const regexOtrosDocumentos = /^([0-9]{3,7})$/i
                        if (!regexOtrosDocumentos.test(value) && value.trim() !== '') message = 'Formato incorrecto de otros documentos'
                        break;
                }
                break;

        }
        dispatch(handleErrorsFormBusquedaDocumento({
            ...errorsFormBusquedaDocumento,
            [field] : message
        }))

        return (message)
    }

    const validateChange = (field: string, value: string) => {
        switch(field){
            case 'nombreTercero':
            case 'nombre':
                return (REGEX_LETRAS_ESPACIOS.test(value))
            case 'descripcion':
                    return validarRegexLetras(value);
            case 'cantidad':
                return validarRegexNumericoFloat2Decimales(value);
            case 'nitTercero':
                    return validarRegexNumericoInt(value);
            case 'precio':
                    return validarRegexNumericoFloat2Decimales(value);
            case 'descuento':
                    return validarRegexNumericoFloat2Decimales(value);
            default:
                return true
        }
    }

    const cargarSucursales = async() => {
        const newFormCliente = { ...formCliente, datosSucursal: [], loadedSucursal: true };

        try {
            let message = 'No se logró obtener el catalogo de sucursales'
            const response: any = await api_getSucursales({
                idsucursal: `${datos.sucursal_seleccionada}`,
                tipodocumento: '04'
            })
            
            if (response.body && !response.message) {
                const sucursal = response.body;
                const hayDocs = sucursal[0]?.Documento?.length;
                
                if (hayDocs) {
                    newFormCliente.datosSucursal = sucursal;
                }
                dispatch(handleSetFormCliente(newFormCliente));
            } else {
                dispatch(generalOpenModalError(response.message || message))
            }
        } catch (error: any) {
            if(error?.response?.data?.errorCode === 1) { dispatch(handleSetFormCliente(newFormCliente)); return; }
            dispatch(generalOpenModalError(error?.response?.data?.message ?? 'Error al obtener las sucursales', error?.response?.data?.status))
        }
    }
    
    const button_onClickAgregarProducto = () => {
        let errors: { [key: string]: string } = {};

        Object.keys(formProducto).forEach((key) => {
            if (validateFormProducto(key, formProducto[key])){
                let propiedad = key
                let value = validateFormProducto(key, formProducto[key])
                errors[propiedad] = value
            }
        })
        dispatch(handleErrorsFormProducto({
            ...errorsProducto,
            ...errors
        }))

        if(Object.values(errors).some((err) => err !== '')){
            dispatch(generalOpenModalInfo('Revisa el formulario de producto'))
            return;
        }

        let tempArray = productos
        tempArray.push(formProducto)
        dispatch(handleAddProducto(tempArray))     
        dispatch(generalOpenModalInfo('Producto agregado correctamente.'))   
        dispatch(handleRestartFormProducto())
    }


    const button_onClickAgregarProductoFisico = () => {
        let errors: { [key: string]: string } = {};
        
        if(!formProducto.documentoAsociado){
            dispatch(generalOpenModalInfo('Debes seleccionar un documento físico.'))
            return;
        }

        Object.keys(formProducto).forEach((key) => {
            if (validateFormProducto(key, formProducto[key])){
                let propiedad = key
                let value = validateFormProducto(key, formProducto[key])
                errors[propiedad] = value
            }
        })
        dispatch(handleErrorsFormProducto({...errorsProducto, ...errors}))

        if(Object.values(errors).some((err) => err !== '')){
            dispatch(generalOpenModalInfo('Revisa el formulario de producto'))
            return;
        }

        let tempArray = productos
        tempArray.push({...formProducto, fisico: true})
        dispatch(handleAddProducto(tempArray))
        dispatch(generalOpenModalInfo('Producto agregado correctamente.'))
        dispatch(handleRestartFormProducto())
    }

    const button_onClickLimpiarFormProducto = () => {
        dispatch(handleRestartFormProducto())
        dispatch(handleErrorsFormProducto({
            ...errorsProducto,
            descripcion: '',
            cantidad: '',
            precio: '',
            descuento: ''
        }))
    }

    const footer_onClickNext = async() => {
        switch (view) {
            case 'Formularios':
                let errors: { [key: string]: string } = {};

                Object.keys(formCliente).forEach((key) => {
                if (validateFormCliente(key, formCliente[key])){
                    let propiedad = key
                    let value = validateFormCliente(key, productoEdit[key])
                    errors[propiedad] = value
                }
                })
                dispatch(handleErrorsFormCliente({
                    ...errorsCliente,
                    ...errors
                }))

                if(Object.values(errors).some((err) => err !== '')){
                    dispatch(generalOpenModalInfo('Revisa los datos del formulario de cliente.'))
                    return;
                }

                if(productos.length === 0){
                    dispatch(generalOpenModalInfo('Debes agregar al menos un producto para continuar.'))
                    return;
                }

                const documentosSinProductos = documentosAsociados.filter(objeto1 => !productos.some(objeto2 => objeto2.codigoGeneracion === objeto1.codigoGeneracion || objeto2.documentoAsociado === objeto1.codigoGeneracion)).map(objeto1 => `<li>${objeto1.numeroControl}</li>`);

                if(documentosSinProductos.length > 0) {
                    dispatch(generalOpenModalInfo(`Los siguientes documentos relacionados no tienen productos asignados, debe agregar al menos un producto por cada documento: <br> <ul>${documentosSinProductos.join("")}</ul>`))
                    return;
                }

                const datosRec:any = dispatch(docsDatosReceptorSiguienteDispatch())
                if(datosRec === true) return;

                try {
                    dispatch(generalShowLoader(true))
                    await Promise.all([
                        dispatch(facturacionGetUUID('04', false))
                    ])
                } finally {
                    dispatch(generalShowLoader(false))
                }
                dispatch(handleChangeView('Previsualizacion'))
                break;
            case 'Previsualizacion':
                dispatch(handleActiveModalEmitir(true))
                break;
            case 'Detalle':
                dispatch(handleActiveModalMasOpciones(true))
                break;
        }
    }

    const footer_onClickBack = () => {
        switch (view) {
            case 'Formularios':
                if(productos.length > 0) dispatch(handleActiveModalQuitarTodo(true))
                break;
            case 'Previsualizacion':
                dispatch(handleChangeView('Formularios'))
                break;
            case 'Detalle':
                dispatch(handleRestarFlujo())
                dispatch(docsDatosReceptorReset())
                break;
        }
    }

    const footer_textButtons = () => {
        let textBack = ''
        let textNext = ''
        let iconBack = ''
        let iconNext = ''
        switch(view){
            case 'Formularios':
                textBack = 'Quitar todo'
                textNext = 'Siguiente'
                iconBack = ''
                iconNext = FlechaDerechaIcon
                break;
            case 'Previsualizacion':
                textBack = 'Anterior'
                textNext = 'Emitir'
                iconBack = ''
                iconNext = EmitirIcon
                break;
            case 'Detalle':
                textBack = 'Emitir nuevo'
                textNext = 'Más opciones'
                iconBack = ''
                iconNext = MasOpcionesIcon
                break;
        }

        return {
            next: {
                text: textNext,
                icon: iconNext
            },
            back: {
                text: textBack,
                icon: iconBack
            }
        }
    }

    const button_onClickQuitarTodo = () => {
        dispatch(handleAddProducto([]))
        modal_cerrarQuitarTodo()
        dispatch(handleSetDocumentosAsociados([]))
        dispatch(generalOpenModalInfo('Se eliminaron todos los productos de la lista'))
    }

    const actionButton_desasociar = (numeroControl: string) => {
        let asociadosArray = documentosAsociados.filter((doc: any) => doc.numeroControl !== numeroControl)
        let productosArray = productos.filter((producto: any) => producto.documentoAsociado !== numeroControl)
        dispatch(handleSetDocumentosAsociados(asociadosArray))
        dispatch(handleAddProducto(productosArray))
    }

    const actionButton_asociar = (documento: any) => {        
        let arrayProductos = productos
        if (documentosAsociados.length > 0) {
            const hasDifferentDocumentType = documentosAsociados.some(producto => producto?.tipoDocumento !== documento?.DetallesDTE?.identificacion?.tipoDte);            
            if (hasDifferentDocumentType) {
                dispatch(generalOpenToastInfo("No es permitido asociar diferentes tipos de documento."));
                return;
            }
            const hasDifferentDocumentNum = documentosAsociados.some(producto => producto?.numeroControl === documento?.DetallesDTE?.identificacion?.numeroControl);            
            if (hasDifferentDocumentNum) {
                dispatch(generalOpenToastInfo(`El número de documento ${documento?.DetallesDTE?.identificacion?.numeroControl} ya se encuentra agregado.`));
                return;
            }
        }

        let documentoObject = {
            numeroControl: documento?.DetallesDTE?.identificacion?.numeroControl,
            codigoGeneracion: documento?.codigogeneracion,
            tipoDocumento: documento?.DetallesDTE?.identificacion?.tipoDte,
            fechaEmision: `${documento?.DetallesDTE?.identificacion?.fecEmi} ${documento?.DetallesDTE?.identificacion?.horEmi}`,
            productos: documento?.DetallesDTE?.cuerpoDocumento?.map((producto: any, index: any) => {

                let productoObject = {
                    servicio : producto.tipoItem === 0,
                    descripcion: producto.descripcion,
                    cantidad: `${producto.cantidad}`,
                    precio: `${producto.precioUni}`,
                    tipoDescuento: "Monto",
                    descuento: `${producto.montoDescu}`,
                    exento: producto.noGravado === 1,
                    conIva: false,
                    documentoAsociado: documento?.CorrelativoSuscripcion, 
                    indexAsociado: index, 
                    codigoGeneracion: documento?.codigogeneracion,
                    unidadMedida: `${producto.uniMedida ?? '59'}`,
                    tipoDte: documento?.DetallesDTE?.identificacion?.tipoDte,
                    clave: producto.codigo,
                    tributos: getTributosCatalogoProducto(producto.codigo),
                } 

                arrayProductos.push(productoObject)
                return (productoObject)
            })
        }
        let tempArray = [...documentosAsociados]
        tempArray.push(documentoObject)
        dispatch(handleSetDocumentosAsociados(tempArray))
        dispatch(handleAddProducto(arrayProductos))
    }

    const actionButton_asociarFisico = (documento: DocFisico) => {
        if (documentosAsociados.length > 0) {
            const hasDifferentDocumentType = documentosAsociados.some(producto => producto?.tipoDocumento !== documento.tipo);            
            if (hasDifferentDocumentType) {
                dispatch(generalOpenToastInfo("No es permitido asociar diferentes tipos de documento."));
                return;
            }
            const hasDifferentDocumentNum = documentosAsociados.some(producto => producto?.codigoGeneracion === documento.numId);            
            if (hasDifferentDocumentNum) {
                dispatch(generalOpenToastInfo(`El número de documento ${documento.numId} ya se encuentra agregado.`));
                return;
            }
        }
        let documentoObject = {
            numeroControl: documento.numId,
            codigoGeneracion: documento.numId,
            tipoDocumento: documento.tipo,
            fechaEmision: documento.fecha,
            productos: [],
            fisico: true,
        }
        let tempArray = [...documentosAsociados]
        tempArray.push(documentoObject)
        dispatch(handleSetDocumentosAsociados(tempArray))
        modal_OpenDocumentoFisico(false)
        dispatch(generalOpenToastInfo(`Documento agregado exitosamente.`));
    }

    const actionButton_editar = (producto: NRFormProducto, index: any) => {
        dispatch(handleSetIndexProductoEdit(index))
        dispatch(handleSetProductoEdit(producto))
        if(producto?.fisico === true) modal_OpenEditarrProdFisico(true)
        else dispatch(handleActiveModalEditar(true))
    }
    
    const modal_cerrarModalEditar = () => {
        button_onClickLimpiarFormProducto()
        dispatch(handleSetIndexProductoEdit(null))
        dispatch(handleActiveModalEditar(false))
        modal_OpenEditarrProdFisico(false)
        dispatch(handleSetProductoEdit({
            ...productoEdit,
            descripcion: '',
            cantidad: '',
            precio: '',
            descuento: ''
        }))
        
    }

    const actionButton_eliminarProducto = (index: any) => {
        dispatch(handleSetIndexProductoEdit(index))
        dispatch(handleActiveModalEliminar(true))
    }
    
    const modal_button_onConfirmEliminar = () => {
        let tempArray = productos
        tempArray.splice(productoIndex, 1)
        dispatch(handleAddProducto(tempArray))
        dispatch(generalOpenModalInfo('Producto eliminado exitosamente.'))
        modal_cerrarModalEliminar()
    }
    
    const modal_cerrarModalEliminar = () => {
        dispatch(handleSetIndexProductoEdit(null))
        dispatch(handleActiveModalEliminar(false))
    }

    const modal_onChangeFormProductoEdit = (field: string, value: string) => {
        if(!validateChange(field, value) && value.trim() !== '') return

        dispatch(handleSetProductoEdit({
            ...productoEdit,
            [field] : value
        }))

        validateFormProducto(field, value)
    }

    const modal_onChangeSelectCatalogoProductoEdit = (codeProduct: string) => {
        const newFormProductoEdit = processFormCatalogoProducto(dteCode, productoEdit, codeProduct)
        dispatch(handleSetProductoEdit({...productoEdit, ...newFormProductoEdit}))
    }

    const modal_button_onConfirmEdit = () => {
        let errors: { [key: string]: string } = {};

        Object.keys(productoEdit).forEach((key) => {
            if (validateFormProducto(key, productoEdit[key])){
                let propiedad = key
                let value = validateFormProducto(key, productoEdit[key])
                errors[propiedad] = value
            }
        })
        dispatch(handleErrorsFormProducto({
            ...errorsProducto,
            ...errors
        }))

        if(Object.values(errors).some((err) => err !== '')){
            dispatch(generalOpenModalInfo('Revisa los datos del producto'))
            return;
        }

        dispatch(generalOpenConfirmEdit(action_onConfirmEdit))
    }
    const action_onConfirmEdit = () => {
        let errors: { [key: string]: string } = {};

        Object.keys(productoEdit).forEach((key) => {
            if (validateFormProducto(key, productoEdit[key])){
                let propiedad = key
                let value = validateFormProducto(key, productoEdit[key])
                errors[propiedad] = value
            }
        })
        dispatch(handleErrorsFormProducto({
            ...errorsProducto,
            ...errors
        }))

        if(Object.values(errors).some((err) => err !== '')){
            dispatch(generalOpenModalInfo('Revisa los datos del producto'))
            return;
        }

        let tempArray = productos
        tempArray[productoIndex] = productoEdit
        dispatch(handleAddProducto(tempArray))
        modal_cerrarModalEditar()
        dispatch(generalOpenModalInfo('Producto actualizado exitosamente.'))
    }

    const modal_cerrarQuitarTodo = () => {
        dispatch(handleActiveModalQuitarTodo(false))
    }

    const modal_cerrarEmitir = () => {
        dispatch(handleActiveModalEmitir(false))
    }

    const modal_button_emitirNuevo = async() => {
        dispatch(handleAddProducto([]))
        await dispatch(handleRestarFlujo())
        dispatch(docsDatosReceptorReset())
        await dispatch(handleSetFormCliente(
            {
                fecha: '',
                tipoDocumento: '',
                noDocumento: '',
                nombre: '',
                departamento: '',
                municipio: '',
                direccion: '',
                email: '',
                chipsEmail: [],
                telefono: '',
                actividad: '',
                actividadDescripcion: '',
                departamentoDescripcion: '',
                municipioDescripcion: '',
                nrc: '',
                
                datosSucursal: [],
                datosDocumento: [],
        
                sucursal: '',
                serie: '',
                loadedSucursal: false,
            }
        ))
        await dispatch(handleAddProducto([]))
        setTimeout(() => {
            dispatch(handleChangeView('Formularios'))
        }, 2)
        dispatch(handleAddProducto([]))
    }

    const obtenerFechas = () => {
        // Obtén la fecha de hoy
        let fechaHoy = new Date();
      
        // Resta 3 meses a la fecha de hoy
        let añoHaceTresMeses = fechaHoy.getFullYear();
        let mesHaceTresMeses = fechaHoy.getMonth() - 3;
      
        // Ajusta el año y el mes si es necesario
        if (mesHaceTresMeses < 0) {
          añoHaceTresMeses -= 1;
          mesHaceTresMeses += 12;
        }
      
        // Obtiene el último día del mes hace 3 meses
        const últimoDíaHaceTresMeses = new Date(añoHaceTresMeses, mesHaceTresMeses + 1, 0).getDate();
      
        // Formatea la fecha hace 3 meses en el formato 'yyyy-MM-dd'
        const fechaFormateadaHaceTresMeses = `${añoHaceTresMeses}-${(mesHaceTresMeses + 1).toString().padStart(2, '0')}-${últimoDíaHaceTresMeses.toString().padStart(2, '0')}`;
      
        // Obtiene el año, mes y día de la fecha actual en formato 'yyyy-MM-dd'
        const añoActual = fechaHoy.getFullYear();
        const mesActual = fechaHoy.getMonth() + 1;
        const díaActual = fechaHoy.getDate();
      
        const fechaFormateadaActual = `${añoActual}-${mesActual.toString().padStart(2, '0')}-${díaActual.toString().padStart(2, '0')}`;
      
        return {
          fechaHaceTresMeses: fechaFormateadaHaceTresMeses,
          fechaActual: fechaFormateadaActual,
        };
    }

    const buttonActiveModalBusquedaDocumentos = (active: boolean) => {  
        dispatch(handleActiveModalBusquedaDocumentos(active))
    }

    const buscarDocumentosAsociados = async() => {
        let errors: { [key: string]: string } = {};

        Object.keys(formBusquedaDocumento).forEach((key) => {
            if (validateFormBusquedaDocumento(key, formBusquedaDocumento[key])){
                let propiedad = key
                let value = validateFormBusquedaDocumento(key, formBusquedaDocumento[key])
                errors[propiedad] = value
            }
        })
        dispatch(handleErrorsFormBusquedaDocumento({
            ...errorsFormBusquedaDocumento,
            ...errors
        }))

        if(Object.values(errors).some((err) => err !== '')){
            dispatch(generalOpenToastInfo('Ingresa los datos de búsqueda correctamente.'))
            return;
        }
            
            dispatch(handleSetDocumentosEncontrados([]))
            dispatch(handleActiveLoaderDocumentosAsociados(true))
            try {

                let body = {
                    fechaInicio: formBusquedaDocumento.fechaInicial || '-1',
                    fechaFin: formBusquedaDocumento.fechaFinal || '-1',
                    tipoDoc: formBusquedaDocumento.tipoIdentificacion || '-1',
                    nit_emisor: datosEmisor.nit, 
                    nrc_receptor: "-1",
                    nrc_emisor: datosEmisor.nrc,
                    doc_receptor: formBusquedaDocumento.noIdentificacion || '-1',
                    tipodte: formBusquedaDocumento.tipoDocumento || '-1',
                    NombreCompleto: formBusquedaDocumento.nombre || '-1',
                    tokenGateway: localStorage.getItem(KEYS.TOKEN),
                  }

                  const response: any = await api_buscarDocumentosAsociados(body)
                  if(response?.body && Array.isArray(response?.body) && response?.body.length > 0){
                    let documentosPermitidos = response.body?.filter((doc: any) => (doc.DetallesDTE.identificacion?.tipoDte === '01' || doc.DetallesDTE.identificacion?.tipoDte === '03' || doc.DetallesDTE.identificacion?.tipoDte === '11'))
                    dispatch(handleSetDocumentosEncontrados(documentosPermitidos))
                    dispatch(generalOpenToastInfo('Documentos asociados al cliente disponibles.'))
                } else {
                    dispatch(handleSetDocumentosEncontrados([]))
                    dispatch(generalOpenToastInfo('No se encontraron documentos por asociados al cliente.'))
                }
                
            } catch (error) {
                dispatch(handleSetDocumentosEncontrados([]))
                dispatch(generalOpenToastInfo('No se encontraron documentos por asociados al cliente.'))
            } finally {
                dispatch(handleActiveLoaderDocumentosAsociados(false))
            }
    }

    const modal_button_limpiarFormBusquedaDocumento = () => {
        dispatch(handleSetFormBusquedaDocumento({
            nombre: '',
            tipoIdentificacion: '',
            noIdentificacion: '',
            fechaInicial: '',
            fechaFinal: '',
            tipoDocumento: ''
        }))

        dispatch(handleErrorsFormBusquedaDocumento({
            nombre: '',
            tipoIdentificacion: '',
            noIdentificacion: '',
            fechaInicial: '',
            fechaFinal: '',
            tipoDocumento: ''
        }))
    }

    const buscarCliente = async() => {
        if(formCliente.tipoDocumento && formCliente.noDocumento && (validateFormCliente('noDocumento', formCliente.noDocumento) === '')){
            // dispatch(generalShowLoader(true))
            try {
                let body = {
                    opcion: '1',
                    tipoDocumento: formCliente.tipoDocumento,
                    numDocumento: formCliente.noDocumento
                }

                const user: any = await api_buscarCliente(body)

                if(user?.body !== null){
                    if (user?.body?.notificarcorreo?.length > 0) { dispatch(generalOpenModalInfo(getEmailNotifyMsg(user.body.notificarcorreo))); }
                    dispatch(handleSetInfoClienteEncontrado(user.body))
                    dispatch(handleActiveModalClienteEncontrado(true))
                } else {
                    dispatch(generalOpenToastInfo('El cliente es nuevo y será registrado al finalizar la factura, para llenarlo automáticamente en un nuevo documento', 'Aviso'))
                    dispatch(handleSetInfoClienteEncontrado(null))
                    dispatch(handleSetFormCliente({
                        ...formCliente,
                        direccion: '',
                        email: '',
                        chipsEmail: [],
                        telefono: '',
                        nrc: '',
                        actividad: '',
                        departamento: '',
                        municipio: ''
                    }))
                }

            } catch (err: any) {
                dispatch(generalOpenToastError(err?.response?.data?.message || 'Se produjo un error al buscar la información del cliente.', "Alerta"))
            } finally {
                dispatch(generalShowLoader(false))
            }
        }
    }

    const modal_button_verDetalle = () => {
        dispatch(handleChangeView('Detalle'))
        dispatch(handleActiveModalEmitido(false))
        modal_cerrarEmitir()
    }

    const modal_cerrarMasOpciones = () => {
        dispatch(handleActiveModalMasOpciones(false))
    }

    const modal_button_cerrarModalEmitido = () => {
        dispatch(handleActiveModalEmitido(false))
    }

    const modal_button_enviarCorreo = () => {
        dispatch(handleActiveModalCorreo(true))
    }

    const modal_button_cerrarEnviarCorreo = () => {
        dispatch(handleActiveModalCorreo(false))
    }

    const modal_button_descargarExcel = async() => {
        try {
            dispatch(generalShowLoader(true))
            await dispatch(getExcelFactura(
                {
                    Documento: response_Emitir.JsonFactura,
                    Sello: response_Emitir.Sello,
                },
                response_Emitir.codigoGeneracion
            ))
        } catch (error) {
            dispatch(generalOpenModalError('Ocurrió un error al descargar el Excel.'))
        } finally {
            dispatch(generalShowLoader(false))
        }
    }

    const modal_button_descargarImagen = async() => {
        try {
            dispatch(generalShowLoader(true))
            await dispatch(getFacturaImage(
                {
                    Documento: response_Emitir.JsonFactura,
                    Sello: response_Emitir.Sello,
                    MostrarPrecio: mostrarDetalle? '1' : '0'
                },
                response_Emitir.codigoGeneracion
            ))
        } catch (error) {
            dispatch(generalOpenModalError('Ocurrió un error al descargar la imagen.'))
        } finally {
            dispatch(generalShowLoader(false))
        }
    }

    const modal_button_descargarPDF = async() => {
        try {
            dispatch(generalShowLoader(true))
            await dispatch(getFacturaPDF_New(
                {
                    Documento: response_Emitir.JsonFactura,
                    Sello: response_Emitir.Sello,
                    MostrarPrecio: mostrarDetalle? '1' : '0'
                },
                response_Emitir.serie,
                response_Emitir.estadoanulacion
            ))
        } catch (error) {
            dispatch(generalOpenModalError('Ocurrió un error al descargar el PDF.'))
        } finally {
            dispatch(generalShowLoader(false))
        }
    }

    const modal_button_imprimir = () => {
        dispatch(handleActiveModalImprimir(true))
    }

    const modal_cerrarImprimir = () => {
        dispatch(handleActiveModalImprimir(false))
    }

    const modal_button_onClickEnviarCorreo = async(email: string) => {
        try {
            dispatch(generalShowLoader(true))
            const sendEmail: OPSendEmail = {
                Correo: email,
                Documento: response_Emitir.JsonFactura,
                Sello: response_Emitir.Sello,
                json: response_Emitir?.JsonFacturaFile || "",
                idSucursal: datos?.sucursal_seleccionada,
                idEmpresa: `${datos?.codigo_empresa}`
            }
            const res:any = await dispatch(sendTransactionEmail(sendEmail))
            if(res){
                dispatch(generalOpenModalMessage('Enviar por correo electrónico', 'El correo electrónico fue enviado exitosamente.'))
                return true;
            }
        } catch (error: any) {
            dispatch(generalOpenModalError(error?.response?.data?.message || 'Ocurrió un error al enviar el correo'))
            return false
        } finally {
            dispatch(generalShowLoader(false))
        }
    }

    const modal_button_descargarJson = () => dispatch(descargarJson({idFactura: response_Emitir?.codigoGeneracion, json: response_Emitir?.JsonFacturaFile}))

    const modal_button_anular = () => {
        dispatch(handleActiveModalAnular(true))
    }

    const modal_cerrarAnular = () => {
        dispatch(handleActiveModalAnular(false))
    }

    const modal_cerrarClienteEncontrado = () => {
        dispatch(handleActiveModalClienteEncontrado(false))
    }

    const modal_button_aceptarClienteEncontrado = async() => {
        let tempForm: { [key: string]: any } = {
            ...formCliente,
            nombre: clienteEncontrado.nombre,
            tipoDocumento: clienteEncontrado.tipoDocumento,
            noDocumento: clienteEncontrado.numDocumento,
            direccion: clienteEncontrado.direccion,
            email: '',
            chipsEmail: clienteEncontrado.email.split(','),
            telefono: clienteEncontrado.telefono,
            nrc: clienteEncontrado.nrc,
            actividad: clienteEncontrado.codActividad,
            departamento: clienteEncontrado.departamento,
            municipio: clienteEncontrado.municipio
        }

        let errors: { [key: string]: string } = {};

        Object.keys(tempForm).forEach((key) => {
            if (validateFormCliente(key, tempForm[key]) && key !== "email"){
                let propiedad = key
                let value = validateFormCliente(key, tempForm[key])
                errors[propiedad] = value
            }
        })
        dispatch(handleErrorsFormCliente({
            ...errors
        }))     
        dispatch(handleSetFormCliente(tempForm))
        modal_cerrarClienteEncontrado()        
    }

    const modal_button_onConfirmAnular = async() => {
        dispatch(generalShowLoader(true))

        try {
            //------------------------
            let documento = formCliente?.datosSucursal?.find((sucursal: any) => sucursal?.idsucursal === formCliente?.sucursal)?.Documento?.find((doc: any) => doc?.idsucursaldocumento === formCliente?.serie)
            let serie = `${documento?.serie}-${documento?.numeroactual}`
            let ivaTotal = 0
            productos.forEach((producto) => {
                let precioUnitario = producto.conIva ? parseFloat(producto.precio)/1.13 : parseFloat(producto.precio)
                let ivaProducto = (precioUnitario * 0.13) * parseFloat(producto.cantidad)
                if(!producto.exento){
                    ivaTotal += ivaProducto
                }
            })
            //------------------------
            
            const anularDoc = {
              documento: response_Emitir.JsonFactura,
              sellorecibido: response_Emitir.Sello,
              DetallesDTE: {
                receptor: {
                  numDocumento: formCliente.noDocumento,
                  tipoDocumento: formCliente.tipoDocumento,
                  nrc: formCliente.nrc,
                  nombre: formCliente.nombre?.trim(),
                  telefono: formCliente.telefono?.trim(),
                  correo: unirChipsReturnFirst(formCliente.chipsEmail, formCliente.email),
                },
                emisor: {
                  nombre: datosEmisor.nombre,
                  nit: datosEmisor.nit,
                  nrc: datosEmisor.nrc,
                  telefono: datosEmisor.telefono,
                  correo: datosEmisor.correo,
                  tipoEstablecimiento: datosEmisor.tipoestablecimiento,
                },
                resumen: {
                  totalIva: isNaN(ivaTotal) ? '0' : `${ivaTotal.toFixed(2)}`,
                },
                identificacion: {
                  tipoDte: '04',
                  codigoGeneracion: response_Emitir.codigoGeneracion,
                  numeroControl: `DTE-04-${serie}`,
                  fecEmi: convertDateFormatAnular(response_Emitir.fhProcesamiento.split(' ')[0]),
                  IDsucursalDoc: documento.idsucursaldocumento
                },
              },
            }
            const response: any = await dispatch(anularFactura_DTE(anularDoc))
            if(response){
                dispatch(generalOpenModalInfo('Documento anulado exitosamente'))
                modal_button_emitirNuevo()
            }
            

        } catch (error: any) {
            dispatch(generalOpenModalError(error?.response?.data?.body?.descripcionMsg || 'Ocurrió un error al anular el documento.'))
        } finally {
            dispatch(generalShowLoader(false))
        }
    }

    const button_asociarDocumentos = () => {
        if(productos.length > 0 || documentosAsociados.length > 0){
            dispatch(handleActiveModalAdvertenciaAsociarDocumentos(true))
            return;
        }
        dispatch(handleActiveAsociarDocumentos(!asociarDocumentos))
    }
    
    const button_modalConfirmChangeAsociarDocumentos = () => {
        dispatch(handleActiveAsociarDocumentos(!asociarDocumentos))
        dispatch(handleAddProducto([]))
        dispatch(handleSetDocumentosAsociados([]))
        modal_button_closeWarningAsociarDocumentos()
    }

    const modal_button_closeWarningAsociarDocumentos = () => {
        dispatch(handleActiveModalAdvertenciaAsociarDocumentos(false))
    }

    const guardarCliente = async() => {
        try {
            let body = {
                opcion: 2,
                tipoDocumento: formCliente.tipoDocumento,
                numDocumento:  formCliente.noDocumento,
                nombre:  formCliente.nombre,
                direccion: formCliente.direccion,
                email: unirChipsJoin(formCliente.chipsEmail, formCliente.email),
                telefono:  formCliente.telefono,
                nrc:  formCliente.nrc,
                codActividad:  formCliente.actividad,
                descActividad:  actividadesEconomicas.find((actividad) => actividad.codigo === formCliente.actividad)?.valor,
                departamento: formCliente.departamento,
                municipio: formCliente.municipio,
              }
            const response: any = await api_buscarCliente(body)
            if (response){
                dispatch(generalOpenToastSuccess(response?.message || "Los datos del cliente han sido guardados satisfactoriamente."))
            }
        } catch (error: any) {
            dispatch(generalOpenToastError(error?.response?.data?.message || 'Se produjo un error al guardar la información del cliente.', "Alerta"))
        }
    }

    const button_mostrarDetalle = (active: boolean) => {
        dispatch(handleActiveMostrarDetalle(active))
    }

    const modal_button_emitirDocumento = async() => {
        dispatch(generalShowLoader(true))
        const horasActuales:any = await dispatch(getFechaHora());
        try{
            const horasActuales: any = await dispatch(getFechaHora())
            guardarCliente()
            // -----------------------------------------------------------------
            let descuentoTotal = 0
            let sumaOperaciones = 0
            let iva = 0
            let subtotal = 0
            let ivaPercibido = 0
            let ivaRetenido = 0
            let retencionRenta = 0
            let total = 0
            let otrosImpuestos = 0
            let resumenTributos:Array<any> = [];

            productos.forEach((producto) => {
                let precioUnitario = producto.conIva ? parseFloat(producto.precio)/1.13 : parseFloat(producto.precio)
                let descuento = isNaN(parseFloat(producto.descuento)) ? 0 : producto.tipoDescuento === 'Porcentaje' ? (precioUnitario * (parseFloat(producto.descuento)/100)) * parseFloat(producto.cantidad) : parseFloat(producto.descuento)
                let ivaProducto = ((precioUnitario * parseFloat(producto.cantidad)) - descuento) * 0.13

                const precio = (precioUnitario * parseFloat(producto.cantidad)) - descuento;
                sumaOperaciones += precio;
                otrosImpuestos += processOtrosImpuestosCalculo(dteCode, producto, precio, false);
                resumenTributos = procesOtrosImpuestosResumen(dteCode, resumenTributos, producto, precio);

                if(!producto.exento){
                    iva += ivaProducto
                    subtotal += ((precioUnitario * parseFloat(producto.cantidad)) - descuento) + ivaProducto
                } else {
                    subtotal += ((precioUnitario * parseFloat(producto.cantidad)) - descuento)
                }
                descuentoTotal += descuento
            })
            
            resumenTributos.forEach((resum) => {
                resum.valor = parseFloat(resum.valor.toFixed(2));
            });

            subtotal += otrosImpuestos;
            total = subtotal;

            let documento = formCliente?.datosSucursal?.find((sucursal: any) => sucursal?.idsucursal === formCliente?.sucursal)?.Documento?.find((doc: any) => doc?.idsucursaldocumento === formCliente?.serie)
            let serie = `${documento?.serie}-${documento?.numeroactual}`
            let impuTotal = iva;

            let body: any = {
                id_user: localStorage.getItem(KEYS.ID_CLIENT),
                tipoContribuyente_receptor: formCliente.granContribuyente,
                facturas:
                [{
                    receptorManual: datosReceptor.nombre,
                    docManual: datosReceptor.numId,
                    esReceptorManual : datosReceptor.esReceptorManual,
                    tipoDocManual : datosReceptor.nombreTipoDocumento,
                    idsucursaldocumento: formCliente.serie,
                    receptorEmailsEnvio: unirChipsJoin(formCliente.chipsEmail, formCliente.email),
                    tipoDte:"04",
                    cveDoc: serie,
                    uuid: datosUUID?.CodigoGeneracion,
                    fechaDoc: horasActuales ? (`${horasActuales.FechaDDMM} ${horasActuales.Hora}`) : `${getFechaFormato1()} ${new Date().toLocaleTimeString([], {hour: '2-digit', minute: '2-digit', second: '2-digit'})}`,
                    canTotal: `${sumaOperaciones.toFixed(2)}`,
                    impuTotal: `${impuTotal.toFixed(2)}`,
                    descuentoTotal: `${descuentoTotal.toFixed(2)}`,
                    cuerpoDocumento: productos.map((producto) => {
                        let precioUni = parseFloat(producto.precio)
                        let impuestoItem = 0
                        let ivaPercibido = 0
                        let ivaRetenido = 0
                        let descuento = 0

                        //CALCULO PRECIO SIN IVA
                        if(producto.conIva){
                            precioUni = parseFloat(producto.precio)/1.13
                        }

                        //CALCULO IVA
                        if(!producto.exento){
                            impuestoItem = (precioUni * parseFloat(producto.cantidad)) * 0.13
                        }


                        //DESCUENTO
                        switch(producto.tipoDescuento){
                            case 'Porcentaje':
                                descuento = (precioUni * (parseFloat(producto.descuento)/100)) * parseFloat(producto.cantidad)
                                break;
                            case 'Monto':
                                descuento = parseFloat(producto.descuento)
                                break;
                        }

                        return ({
                            numeroDocumentoDte: producto.documentoAsociado || undefined,
                            cantidad: `${parseFloat(producto.cantidad).toFixed(2)}`,
                            precioUni: `${precioUni.toFixed(2)}`,
                            descripcion: producto.descripcion,
                            descuento: isNaN(descuento) ? '0' : `${descuento.toFixed(2)}`,
                            numeroDocumento: producto?.fisico === true ? producto?.documentoAsociado :  producto?.codigoGeneracion || undefined,
                            unidad: producto?.unidadMedida || undefined,
                            descUnidad: unidadesMedida.find((unidad) => unidad.codigo === producto.unidadMedida)?.valor || undefined,
                            tributos: producto.tributos ?? [],
                            codigo: producto.clave ?? '',
                        })
                    }),
                    // ventaTercero: null,
                    // ventaTercero: (!formCliente.nitTercero || formCliente.nitTercero === '' || !formCliente.nombreTercero || formCliente.nombreTercero === '') ? undefined : 
                    // {
                    //     nit: formCliente.nitTercero,
                    //     nombre: formCliente.nombreTercero
                    // },
                    docRelacionado: documentosAsociados.map((doc) => ({
                        tipoGeneracion: doc?.fisico === true ? 1 : 2,
                        tipoDocumento: doc?.tipoDocumento,
                        numeroDocumento: doc?.codigoGeneracion,
                        numeroDocumentoDte: doc?.fisico === true ? doc?.codigoGeneracion : doc?.numeroControl,
                        fechaEmision: doc?.fechaEmision,
                        tipoDocRelDesc: tipoDocumentosEmision.find((documento) => documento.codigodocumento === doc?.tipoDocumento)?.nombre,
                        fechaDocRel: doc?.fisico === true ? getFechaCA(doc?.fechaEmision)  : `${doc.fechaEmision.split(' ')[0].split('-')[2]}/${doc.fechaEmision.split(' ')[0].split('-')[1]}/${doc.fechaEmision.split(' ')[0].split('-')[0]}`
                    })),
                    receptor: {
                        tipoDocumento: formCliente.tipoDocumento,
                        numDocumentoReceptor: formCliente.noDocumento,
                        nrc: formCliente.nrc,
                        nombre: formCliente.nombre,
                        direccion: formCliente.direccion,
                        email: unirChipsReturnFirst(formCliente.chipsEmail, formCliente.email),
                        telefono: formCliente.telefono,
                        codActividad: formCliente.actividad,
                        descAtvividad: actividadesEconomicas.find((actividad) => actividad.codigo === formCliente.actividad)?.valor,
                        departamento: formCliente.departamento,
                        municipio: formCliente.municipio,
                    },
                    ivaRete1: `${ivaPercibido.toFixed(2)}`,
                    ivaPerci1: `${ivaRetenido.toFixed(2)}`,
                    reteRenta: `${retencionRenta.toFixed(2)}`,
                    tributos: resumenTributos,
                  }],
                    tokenGateway: localStorage.getItem(KEYS.TOKEN) ?? '',
                    tokenHacienda: localStorage.getItem(KEYS.HACIENDA) ?? '',
                    idSucursal: datos?.sucursal_seleccionada,
                    idEmpresa: `${datos?.codigo_empresa}`
                }

                const response: any = await api_RecepcionDTE(body)
                if(response.body.estado === 'PROCESADO'){
                    if(response?.body?.NuevoToken){
                        localStorage.setItem(KEYS.HACIENDA, response?.body?.TokenHacienda)
                      }
                    dispatch(handleSetResponseEmitir(response.body))
                    dispatch(handleActiveModalEmitido(true))
                    dispatch(handleActiveModalEmitir(false))
                    dispatch(handleChangeView('Detalle'))
                  const qrResponse = await getQR(response.body.JsonFactura)
                  if(qrResponse.qr){
                      let qrString = generateQRImageFromBits(qrResponse.qr?.replace("data:image/jpeg;base64,", ""))
                      dispatch(handleSetQRCode(qrString))
                  } else {
                      dispatch(generalOpenModalError(qrResponse.message || 'Ocurrió un error al obtener el código QR'))
                  }
                }

        } catch (err: any) {
            let message = 'Ocurrió un error al emitir el crédito fiscal, contacta al administrador.'

            if(err.response.data.message) message = err.response.data.message
            else {
                try{
                    let messageDesc = err?.response?.data?.body?.descripcionMsg?.replace(/\[(\w+)\.(\w+)\]\s(\w+)/, '$2 de $1 : $3').toUpperCase()
                    message = messageDesc || message
                } catch {
                    message = 'Ocurrió un error al emitir el crédito fiscal, contacta al administrador.'
                }
            }

            dispatch(generalOpenModalError(message))
        } finally {
            dispatch(generalShowLoader(false))
        }
    }

    const setTableProductos = (table: any) => {
        dispatch(handleSetTableProductos(table))
    }
    
    const modal_OpenDocumentoFisico = (flag: boolean) => dispatch(handleActiveModalDocFisico(flag))
    const modal_OpenAgregarProdFisico = (flag: boolean) => dispatch(handleActiveModalAgregarProductoFisico(flag))
    const modal_OpenEditarrProdFisico = (flag: boolean) => dispatch(handleActiveModalEditarProductoFisico(flag))
    

    useEffect(() => {
        
        let precioUnitario = formProducto.conIva ? parseFloat(formProducto.precio)/1.13 : parseFloat(formProducto.precio)
        let descuento = 0
        if(formProducto.tipoDescuento === 'Porcentaje'){
            descuento = isNaN(parseFloat(formProducto.descuento)) ? 0 : (precioUnitario * parseFloat(formProducto.descuento)/100) * parseFloat(formProducto.cantidad)
        } else {
            descuento = isNaN(parseFloat(formProducto.descuento)) ? 0 : parseFloat(formProducto.descuento)
        }
        let neto = (parseFloat(formProducto.cantidad) * precioUnitario) 
        let subtotal = neto - descuento
        let iva = subtotal * 0.13
        let otrosImpuestos = processOtrosImpuestosCalculo(dteCode, formProducto, subtotal);

        if(formProducto.exento) iva = 0
        let total = subtotal + iva;
        
        dispatch(handleCalculosProducto({
            neto: isNaN(neto) ? '$0.00' : neto.toLocaleString('es-SV', {minimumFractionDigits: 2, maximumFractionDigits: 2, style: 'currency', currency: 'USD'}),
            subtotal: isNaN(subtotal) ? '$0.00' : subtotal.toLocaleString('es-SV', {minimumFractionDigits: 2, maximumFractionDigits: 2, style: 'currency', currency: 'USD'}),
            descuento: isNaN(descuento) ? '$0.00' : descuento.toLocaleString('es-SV', {minimumFractionDigits: 2, maximumFractionDigits: 2, style: 'currency', currency: 'USD'}),
            total: isNaN(total) ? '$0.00' : total.toLocaleString('es-SV', {minimumFractionDigits: 2, maximumFractionDigits: 2, style: 'currency', currency: 'USD'}),
            iva: isNaN(iva) ? '$0.00' : iva.toLocaleString('es-SV', {minimumFractionDigits: 2, maximumFractionDigits: 2, style: 'currency', currency: 'USD'}),
            otrosImpuestos: isNaN(otrosImpuestos) ? '$0.00' : otrosImpuestos.toLocaleString('es-SV', {minimumFractionDigits: 2, maximumFractionDigits: 2, style: 'currency', currency: 'USD'})
        }))
    }, [formProducto])

    useEffect(() => {
        if(formCliente.tipoDocumento && formCliente.tipoDocumento !== '') validateFormCliente('noDocumento', formCliente.noDocumento)
    }, [formCliente.tipoDocumento])

    useEffect(() => {
        if(Array.isArray(formCliente.datosSucursal) && formCliente.datosSucursal.length > 0) cargarDatosIniciales()
    }, [formCliente.datosSucursal])

    useEffect(() => {
        if(Array.isArray(formCliente.datosSucursal) && formCliente.datosSucursal.length > 0) cargarDatosIniciales()
        else if (formCliente.loadedSucursal) {
            dispatch(showMessageSucursalVacia('Nota de remisión'));
            history.push('/otros-documentos');
            dispatch(handleRestarFlujo());
        }
    }, [formCliente.datosSucursal, formCliente.loadedSucursal])

    useEffect(() => {
        let arrayAsociados = documentosAsociados
        documentosAsociados?.forEach((documento) => {
            if(!productos.some((producto) => producto.documentoAsociado === documento.numeroControl)){
                arrayAsociados = arrayAsociados.filter((doc) => doc.numeroControl !== documento.numeroControl)
            }
        })
        if(documentosAsociados.length > 0) {
            const arrayFilter = documentosAsociados.filter(objeto2 => {
                return !arrayAsociados.some(objeto1 => objeto1.numeroControl === objeto2.numeroControl) && objeto2.fisico === true;
            });
            arrayAsociados = [...arrayAsociados, ...arrayFilter]
        }

        dispatch(handleSetDocumentosAsociados(arrayAsociados))
    }, [productos.length])

    return {
        cargarSucursales,
        cargarDatosIniciales,
        buscarCliente,
        buscarDocumentosAsociados,

        onChangeFormCliente,
        onChangeFormProducto,
        onChangeFormBusquedaDocumento,
        onChangeSelectCatalogoProducto,

        validateFormCliente,
        validateFormProducto,

        button_onClickAgregarProducto,
        button_onClickLimpiarFormProducto,
        button_onClickQuitarTodo,
        button_asociarDocumentos,

        footer_onClickBack,
        footer_onClickNext,
        footer_textButtons,

        actionButton_editar,
        actionButton_eliminarProducto,
        actionButton_asociar,
        actionButton_desasociar,

        modal_cerrarQuitarTodo,
        modal_cerrarModalEditar,
        modal_cerrarModalEliminar,
        modal_cerrarEmitir,
        modal_cerrarMasOpciones,
        modal_cerrarImprimir,
        modal_cerrarAnular,
        modal_cerrarClienteEncontrado,

        modal_button_onConfirmEdit,
        modal_button_onConfirmEliminar,
        modal_button_emitirDocumento,
        modal_button_emitirNuevo,
        modal_button_verDetalle,
        modal_button_cerrarModalEmitido,    
        modal_button_enviarCorreo,
        modal_button_cerrarEnviarCorreo,
        modal_button_onClickEnviarCorreo,
        modal_button_descargarExcel,
        modal_button_descargarImagen,
        modal_button_descargarPDF,
        modal_button_imprimir,
        modal_button_anular,
        modal_button_onConfirmAnular,
        modal_button_aceptarClienteEncontrado,
        modal_button_limpiarFormBusquedaDocumento,
        button_modalConfirmChangeAsociarDocumentos,
        modal_button_descargarJson,

        modal_onChangeFormProductoEdit,
        modal_onChangeSelectCatalogoProductoEdit,
        modal_button_closeWarningAsociarDocumentos,
        buttonActiveModalBusquedaDocumentos,
        button_mostrarDetalle,
        setTableProductos,
        actionButton_asociarFisico,
        modal_OpenDocumentoFisico,
        modal_OpenAgregarProdFisico,
        button_onClickAgregarProductoFisico,
        modal_OpenEditarrProdFisico
    }
}

const handleSetFormCliente = (form: any):ActionNR => ({type: NOTA_REMISION_TYPES.NR_SET_FORM_CLIENTE, payload: form})
const handleSetFormProducto = (form: any):ActionNR => ({type: NOTA_REMISION_TYPES.NR_SET_FORM_PRODUCTO, payload: form})
const handleSetFormBusquedaDocumento = (form: any):ActionNR => ({type: NOTA_REMISION_TYPES.NR_SET_FORM_BUSQUEDA_DOCUMENTO, payload: form})
const handleErrorsFormCliente = (errors: any):ActionNR => ({type: NOTA_REMISION_TYPES.NR_HANDLE_ERRORS_CLIENTE, payload:errors})
const handleErrorsFormProducto = (errors: any):ActionNR => ({type: NOTA_REMISION_TYPES.NR_HANDLE_ERRORS_PRODUCTO, payload:errors})
const handleErrorsFormBusquedaDocumento = (errors: any):ActionNR => ({type: NOTA_REMISION_TYPES.NR_HANDLE_ERRORS_BUSQUEDA_DOCUMENTO, payload:errors})
const handleCalculosProducto = (calculos: any):ActionNR => ({type: NOTA_REMISION_TYPES.NR_SET_CALCULOS_PRODUCTO, payload: calculos})
const handleAddProducto = (productos: any):ActionNR => ({type: NOTA_REMISION_TYPES.NR_SET_PRODUCTOS, payload: productos})
const handleRestartFormProducto = ():ActionNR => ({type: NOTA_REMISION_TYPES.NR_RESTART_FORM_PRODUCTO, payload: null})
const handleChangeView = (view: string):ActionNR => ({type: NOTA_REMISION_TYPES.NR_SET_VIEW, payload: view})
const handleActiveModalQuitarTodo = (active: boolean):ActionNR => ({type: NOTA_REMISION_TYPES.NR_ACTIVE_MODAL_QUITAR_TODO, payload: active})
const handleActiveModalEditar = (active: boolean):ActionNR => ({type: NOTA_REMISION_TYPES.NR_ACTIVE_MODAL_EDITAR_PRODUCTO, payload: active})
const handleActiveModalEliminar = (active: boolean):ActionNR => ({type: NOTA_REMISION_TYPES.NR_ACTIVE_MODAL_ELIMINAR_PRODUCTO, payload: active})
const handleActiveModalEmitir = (active: boolean):ActionNR => ({type: NOTA_REMISION_TYPES.NR_ACTIVE_MODAL_EMITIR, payload: active})
const handleActiveModalEmitido = (active: boolean):ActionNR => ({type: NOTA_REMISION_TYPES.NR_ACTIVE_MODAL_EMITIDO, payload: active})
const handleActiveModalMasOpciones = (active: boolean):ActionNR => ({type: NOTA_REMISION_TYPES.NR_ACTIVE_MODAL_MAS_OPCIONES, payload: active})
const handleActiveModalCorreo = (active: boolean):ActionNR => ({type: NOTA_REMISION_TYPES.NR_ACTIVE_MODAL_ENVIAR_CORREO, payload: active})
const handleActiveModalImprimir = (active: boolean):ActionNR => ({type: NOTA_REMISION_TYPES.NR_ACTIVE_MODAL_IMPRIMIR, payload: active})
const handleActiveModalClienteEncontrado = (active: boolean):ActionNR => ({type: NOTA_REMISION_TYPES.NR_ACTIVE_MODAL_CLIENTE_ENCONTRADO, payload: active})
const handleActiveModalAnular = (active: boolean):ActionNR => ({type: NOTA_REMISION_TYPES.NR_ACTIVE_MODAL_ANULAR, payload: active})
const handleActiveModalBusquedaDocumentos = (active: boolean):ActionNR => ({type: NOTA_REMISION_TYPES.NR_ACTIVE_MODAL_BUSQUEDA_DOCUMENTO, payload: active})
const handleActiveModalAnulado = (active: boolean):ActionNR => ({type: NOTA_REMISION_TYPES.NR_ACTIVE_MODAL_ANULADO, payload: active})
const handleSetProductoEdit = (producto: any):ActionNR => ({type: NOTA_REMISION_TYPES.NR_SET_PRODUCTO_EDIT, payload: producto})
const handleSetIndexProductoEdit = (index: any):ActionNR => ({type: NOTA_REMISION_TYPES.NR_SET_PRODUCTO_INDEX, payload: index})
const handleSetResponseEmitir = (response: any):ActionNR => ({type: NOTA_REMISION_TYPES.NR_SET_RESPONSE_EMITIR, payload: response})
const handleSetQRCode = (qr: any):ActionNR => ({type: NOTA_REMISION_TYPES.NR_SET_QR_CODE, payload: qr})
export const handleRestarFlujo = ():ActionNR => ({type: NOTA_REMISION_TYPES.NR_RESTART_ALL, payload: ''})
const handleSetInfoClienteEncontrado = (info: any):ActionNR => ({type: NOTA_REMISION_TYPES.NR_SET_CLIENTE_ENCONTRADO, payload: info})
const handleActiveAsociarDocumentos = (active: boolean):ActionNR => ({type: NOTA_REMISION_TYPES.NR_ACTIVE_ASOCIAR_DOCUMENTOS, payload: active})
const handleSetDocumentosEncontrados = (documentos: any):ActionNR => ({type: NOTA_REMISION_TYPES.NR_SET_DOCUMENTOS_ENCONTRADOS, payload: documentos})
const handleSetDocumentosAsociados = (documentos: any):ActionNR => ({type: NOTA_REMISION_TYPES.NR_SET_DOCUMENTOS_ASOCIADOS, payload: documentos})
const handleActiveLoaderDocumentosAsociados = (active: boolean):ActionNR => ({type: NOTA_REMISION_TYPES.NR_SET_LOADER_DOCUMENTOS_ASOCIADOS, payload: active})
const handleActiveModalAdvertenciaAsociarDocumentos = (active: boolean):ActionNR => ({type: NOTA_REMISION_TYPES.NR_ACTIVE_ADVERTENCIA_ASOCIAR_DOCUMENTOS, payload: active})
const handleActiveMostrarDetalle = (active: boolean):ActionNR => ({type: NOTA_REMISION_TYPES.NR_HANDLE_ACTIVE_MOSTRAR_DETALLE, payload: active})
const handleSetTableProductos = (table: any):ActionNR => ({type: NOTA_REMISION_TYPES.NR_SET_TABLE_PRODUCTOS, payload: table})
const handleActiveModalDocFisico = (active: boolean):ActionNR => ({type: NOTA_REMISION_TYPES.NR_ACTIVE_MODAL_DOCUMENTO_FISICO, payload: active})
const handleActiveModalAgregarProductoFisico = (active: boolean):ActionNR => ({type: NOTA_REMISION_TYPES.NR_ACTIVE_MODAL_PRODUCTO_FISICO, payload: active})
const handleActiveModalEditarProductoFisico = (active: boolean):ActionNR => ({type: NOTA_REMISION_TYPES.NR_ACTIVE_MODAL_EDITAR_PRODUCTO_FISICO, payload: active})

const api_getSucursales = (body: any) => http.post(ENDPOINTS.GESTION_USUARIO_POST_SUCURSALES, body, {}, KEYS.TOKEN)
const api_RecepcionDTE = (body: any) => http.post(ENDPOINTS.FACTURACION_POST_RECEPCION_DTE, body, {}, KEYS.TOKEN)
const api_buscarCliente = (body: any) => http.post(ENDPOINTS.CLIENTE_RECEPTOR_GUARDAR, body,  {}, KEYS.TOKEN)
const api_buscarDocumentosAsociados = (body: any) => http.post(ENDPOINTS.GET_HISTORIAL_TRANSACCIONES, body, {}, KEYS.TOKEN)
